import { AppointmentsFilter } from '@grow-therapy-team/seedling-components';

import { Exact, InputMaybe, Maybe } from '../../types';

// Types for IntersessionSummary consolidated query
export type IntersessionSummary__ProgressNoteItem = {
  label: string;
  item: string;
};

export type IntersessionSummary__IntakePreVisitSummaryContent = {
  __typename: 'IntakePreVisitSummaryContentObject';
  generatedCoachTopics?: Maybe<string[]>;
  currentPhqCategory?: Maybe<string>;
  currentGadCategory?: Maybe<string>;
};

export type IntersessionSummary__FollowUpPreVisitSummaryContent = {
  __typename: 'FollowUpPreVisitSummaryContentObject';
  progressNote?: Maybe<IntersessionSummary__ProgressNoteItem[]>;
  reflectionTopics?: Maybe<string[]>;
  completedResources?: Maybe<string[]>;
  generatedCoachTopics?: Maybe<string[]>;
  currentPhqCategory?: Maybe<string>;
  currentGadCategory?: Maybe<string>;
  phqDifference?: Maybe<number>;
  gadDifference?: Maybe<number>;
};

export type IntersessionSummary__PreVisitSummary = {
  createdAt: string;
  content?: Maybe<
    IntersessionSummary__IntakePreVisitSummaryContent | IntersessionSummary__FollowUpPreVisitSummaryContent
  >;
};

export type IntersessionSummary__Patient = {
  id: string;
  shortId: string;
  firstName: string;
  preferredFullName: string;
  pronouns?: Maybe<string>;
  clientUser: {
    shortId: string;
  };
};

export type IntersessionSummary__RecurringAppointmentGrouping = {
  indefinite?: Maybe<boolean>;
  recurringAppointmentGroupingId?: Maybe<string>;
  weeksBetween?: Maybe<number>;
  recurrenceRule?: Maybe<string>;
  version?: Maybe<number>;
  appointments?: Maybe<Array<{ id: string; timeStart: string }>>;
};

export type IntersessionSummary__Appointment = {
  id: string;
  appointmentShortId: string;
  appointmentType: string;
  timeStart: string;
  timeEnd: string;
  inOffice?: Maybe<boolean>;
  patient?: Maybe<IntersessionSummary__Patient>;
  recurringAppointmentGrouping?: Maybe<IntersessionSummary__RecurringAppointmentGrouping>;
  preVisitSummary?: Maybe<IntersessionSummary__PreVisitSummary>;
};

export type IntersessionSummary__AppointmentEdge = {
  __typename?: 'AppointmentObjectEdge';
  node?: Maybe<IntersessionSummary__Appointment>;
};

export type IntersessionSummary__AppointmentsConnection = {
  __typename?: 'AppointmentObjectConnection';
  edges: Array<Maybe<IntersessionSummary__AppointmentEdge>>;
};

export type IntersessionSummaryConnected__GetUpcomingAppointmentForPatientQuery = {
  __typename?: 'Query';
  allAppointments?: Maybe<IntersessionSummary__AppointmentsConnection>;
};

export type IntersessionSummaryConnected__GetUpcomingAppointmentForPatientQueryVariables = Exact<{
  filters?: InputMaybe<AppointmentsFilter>;
}>;

// Types for GetCoachAccessInfo query
export enum CoachUserType {
  CLIENT_USER = 'CLIENT_USER',
  PROVIDER = 'PROVIDER',
}

export enum CoachDisabledByType {
  NOT_RELEASED_TO_USER = 'NOT_RELEASED_TO_USER',
}

export type GetCoachAccessInfo__DisabledReason = {
  disabledByType?: Maybe<CoachDisabledByType>;
};

export type GetCoachAccessInfo__CoachAccess = {
  userId: string;
  userType: CoachUserType;
  canUpdateAccess: boolean;
  enabled: boolean;
  disabledReasons?: Maybe<GetCoachAccessInfo__DisabledReason[]>;
};

export type GetCoachAccessInfoQuery = {
  __typename?: 'Query';
  coachAccess?: Maybe<GetCoachAccessInfo__CoachAccess>;
};

export type GetCoachAccessInfoQueryVariables = Exact<{
  userId: string;
  userType?: InputMaybe<CoachUserType>;
}>;
